"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = (dayName) => {
    switch (dayName) {
        case "monday":
            return 0;
        case "tuesday":
            return 1;
        case "wednesday":
            return 2;
        case "thursday":
            return 3;
        case "friday":
            return 4;
        case "saturday":
            return 5;
        case "sunday":
            return 6;
    }
    throw new Error(`${dayName} is out of range. Name should be in english and lowercase`);
};
//# sourceMappingURL=DayOfWeekAdapter.js.map